import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center gap-2 bg-warning px-4 py-2 text-warning-foreground text-sm font-medium shadow-lg animate-slide-in-up">
      <WifiOff className="h-4 w-4" />
      <span>Sin conexión — Mostrando datos en caché</span>
    </div>
  );
}
